<!-- 告警抑制页面 -->
<template>
  <div class="devicePermission-container">
    <div class="devicePermission-search">
      <el-form
        :inline="true"
        :model="formInline"
        style="position: relative; width: 100%; height: 41px"
        class="demo-form-inline"
      >
        <el-form-item label="设备名称">
          <el-input
            v-model="formInline.deviceName"
            @keyup.enter.native="searchResult"
            placeholder="请输入设备名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="系统/类型">
          <el-cascader
            :options="alarmTypeList"
            v-model="alarmList"
            @keyup.enter.native="searchResult"
            placeholder="请选择系统及类型"
            @change="cascaderChange"
            :props="{ label: 'name', value: 'id' }"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button class="query-btn" type="primary" @click="searchResult">{{
            $t("accountGroup.button.query")
          }}</el-button>
          <el-button type="info" @click="resetQuery">{{
            $t("accountGroup.button.reset")
          }}</el-button>
        </el-form-item>
        <el-form-item style="position: absolute; right: -10px">
          <!-- <el-upload
                        ref="upload"
                        style="margin-right: 10px"
                        class="upload-demo"
                        multiple
                        :limit="1"
                        :auto-upload="false"
                        :on-change="batchImport"
                        action
                        :disabled="importFile"
                        :show-file-list="false"
                      >
                        <el-button
                          type="primary"
                          :loading="importFile"
                          v-auth="'/deviceaccess/alarmInhibition:import'"
                          class="iss-operation-button-upload"
                          icon="iconfont icon-daoru"
                          size="small"
                          >{{ importFile ? "数据导入中" : "批量导入" }}</el-button
                        >
                      </el-upload>
                      <el-button
                        class="iss-operation-button-download"
                        icon="el-icon-download"
                        @click="downTemplate"
                        size="large"
                        >模板下载</el-button
                      > -->

          <el-button size="small" type="primary" @click="goBack">
            <i class="iconfont icon-iconfontfanhui" />
            <span>返回</span>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 右侧表格 -->
    <div
      style="height: 100%"
      v-loading="dataLoading"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
    >
      <ioc-table
        ref="accessTab"
        :data="tableData"
        :option="permissionOption"
        :page="page"
        @selection-change="handleSelectionChange"
        @current-change="selectPage"
        @size-change="changeSize"
      >
        <template slot="menuLeft">
          <el-button
            type="primary"
            class="iss-operation-button"
            icon="el-icon-delete"
            v-auth="'/deviceaccess/alarmInhibition:delete'"
            @click="batchDelete"
            size="small"
          >
            批量删除
          </el-button>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="查看"
            placement="top"
            popper-class="tooltip-draw"
          >
            <el-button
              type="text"
              icon="iconfont icon-Detail"
              @click="handleView(scope.row, scope.index)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="修改"
            placement="top"
            popper-class="tooltip-draw"
          >
            <el-button
              type="text"
              icon="iconfont icon-xiugai"
              @click="handleEdit(scope.row, scope.index)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
            popper-class="tooltip-draw"
          >
            <el-button
              type="text"
              icon="iconfont icon-shanchu"
              @click="handleDel(scope.row, 1)"
            ></el-button>
          </el-tooltip>
        </template>
      </ioc-table>
      <!-- </div> -->
      <!-- </div> -->
    </div>
    <alarmControl @alarmControl="alarmControl" ref="alarmContol"></alarmControl>
  </div>
</template>
<script>
import { api } from "../api";
import { Dic, Bus, Dates } from "$utils";
import utils from "$utils";
import alarmControl from "../../realTimeAlarm/components/alarmControl";
import i18n from "@src/common/lib/i18n";
export default {
  components: {
    alarmControl,
  },
  data() {
    return {
      formInline: {
        deviceName: "",
      },
      alarmList: [],
      alarmTypeList: [],
      dataLoading: false,
      permissionOption: {
        stripe: true,
        page: true,
        menuAlign: "center",
        header: false,
        delBtn: false,
        editBtn: false,
        menu: false,
        index: true,
        indexLabel: "序号",
        labelSuffix: " : ",
        selection: true,
        emptyText: this.$t("deviceAccess.message.nodata"),
        column: [
          {
            label: "子系统",
            prop: "subSystemLabel",
          },
          {
            label: "告警类型",
            prop: "alarmTypeLabel",
          },
          {
            label: "车牌号",
            prop: "plateNo",
          },
          {
            label: "设备名称",
            prop: "deviceName",
            span: 24,
          },
          {
            label: "设备编号",
            prop: "thirdDeviceId",
          },
          {
            label: "时间周期 /s",
            prop: "alarmInterval",
            slot: true,
            span: 24,
          },
          {
            label: "开始时间",
            prop: "beginTime",
            span: 24,
            slot: true,
          },
          {
            label: "结束时间",
            prop: "endTime",
            span: 24,
            slot: true,
          },
        ],
      },
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        subSystem: "",
        alarmType: "",
        deviceName: "",
      },
      tableData: [],
      downFileName: "importAlarmIgnoreConfig",
      // 列表查询参数
      searchParams: {},
      alarmIgnoreCodeList: [],
      importFile: false,
    };
  },
  created() {
    this.getAlarmTypeList();
  },
  mounted() {
    this.getList();
  },
  methods: {
    goBack() {
      // if (this.$route.query.type) {
    //   this.$router.push("/deviceaccess/eventconfignew");
      // } else {
        this.$router.push("/deviceaccess/fireEventConfig");
      // }
    },
    batchImport(file) {
      if (
        file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length) !==
          "xlsx" &&
        file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length) !== "xls"
      ) {
        this.$message({
          message: "文件格式不正确",
          type: "warning",
        });
      } else {
        this.importFile = true;
        let formData = new FormData();
        formData.append("file", file.raw);
        // 调用导入接口
        this.$fetch(api.device.importTemplateFile, formData).then((response) => {
          setTimeout(() => {
            this.importFile = false;
          }, 500);
          if (response.success) {
            this.$message({
              message: "导入文件成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
            });
          }
          this.$refs.upload.clearFiles();
        });
      }
    },
    downTemplate() {
      this.$fetchGet(api.device.getTemplateFile, {
        responseType: "blob", //设置返回类型
      }).then((res) => {
        if (typeof window.chrome !== "undefined") {
          // Chrome version
          const blob = new Blob([res], { type: "application/vnd.ms-excel" });
          const url = window.URL || window.webkitURL || window.moxURL;
          const urls = url.createObjectURL(blob);
          const a = document.createElement("a"); // 生成虚拟a标签
          a.href = urls;
          a.download = this.downFileName + ".xlsx";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          url.revokeObjectURL(urls); // 释放掉blob对象
        } else if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE version
          const blob = new Blob([res], { type: "application/force-download" });
          window.navigator.msSaveBlob(blob, this.downFileName + ".xlsx");
        } else {
          // Firefox version
          const file = new File([res], this.downFileName + ".xlsx", {
            type: "application/force-download",
          });
          window.open(URL.createObjectURL(file));
        }
      });
    },
    cascaderChange(val) {
      this.page.subSystem = val[0] || "";
      this.page.alarmType = val[1] || "";
    },
    getAlarmTypeList() {
      this.alarmTypeList = [];
      this.$fetch(api.device.getAlarmTypeAndSubsystem).then((res) => {
        if (res.success) {
          this.dataLoading = false;
          if (this.$route.query.type) {
            this.alarmTypeList = res.returnObj.filter((el) => {
              let id = el.id;
              if (id != 4 && id != 13 && id != 14) {
                return el;
              }
            });
          } else {
            this.alarmTypeList = res.returnObj.filter((el) => {
              let id = el.id;
              if (id == 4 || id == 13 || id == 14) {
                return el;
              }
            });
          }
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    alarmControl(val, data) {
      // let params = {
      //   subSystem: data.subSystem,
      //   alarmType: data.alarmType,
      //   alarmDevId: data.alarmDevId,
      //   deviceName: data.deviceName,
      //   alarmInterval: val.num,
      //   beginTime: val.ignoreTime && val.ignoreTime[0],
      //   endTime: val.ignoreTime && val.ignoreTime[1],
      // };
      // this.$fetch(api.device.updateAlarmIgnoreConfig, params).then((res) => {
      //   if (res.success) {
      //     this.$message.success("告警抑制修改成功");
      //     this.$refs.alarmContol.closeDialog();
      this.getList();
      //   } else {
      //     this.$refs.alarmContol.sbmitLoading = false;
      //     this.$message.error(res.msgContent);
      //   }
      // });
    },
    // 获取列表
    getList() {
      this.dataLoading = true;
      this.page.deviceName = this.formInline.deviceName;
      let params = Object.assign({}, this.page);
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      params.pageNum = params.currentPage;
      params.subSystem = '4, 13'
      delete params.total;
      delete params.currentPage;
      this.$fetch(api.device.queryAlarmIgnoreConfigList, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          this.dataLoading = false;
          this.$message.error(response.msgContent);
          return;
        }
        this.dataLoading = false;
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.accessTab.selectClear();
      });
    },
    // 查看详情
    handleView(row, index) {
      this.$refs.accessTab.rowView(row, index);
    },
    // 修改
    handleEdit(row, index) {
      console.log(row);
      this.$refs.alarmContol.alarmData = row;
      this.$refs.alarmContol.formDialog = {
        ignoreTime: row ? [row.beginTime || "", row.endTime || ""] : [],
        num: row ? row.alarmInterval : 0,
      };
      this.$refs.alarmContol.controlDialog = true;
    },
    handleSelectionChange(items) {
      this.alarmIgnoreCodeList = items.map((item) => {
        return item.alarmIgnoreCode;
      });
    },
    // 删除
    handleDel(row, isall = 1) {
      const params = {
        alarmIgnoreCodeList: isall == 2 ? row : [row.alarmIgnoreCode],
      };
      this.$confirm("您确定删除该告警抑制吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.device.deleteAlarmIgnoreConfig, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          this.$message.success("删除成功");
          this.getList();
        });
      });
    },
    // 批量删除
    batchDelete() {
      if (this.alarmIgnoreCodeList.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择你要删除的数据",
        });
        return;
      }
      this.handleDel(this.alarmIgnoreCodeList, 2);
    },
    // 查询按钮事件
    searchResult() {
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      (this.page.subSystem = ""), (this.page.alarmType = ""), (this.alarmList = []);
      this.formInline.deviceName = "";
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.el-cascader-panel {
  font-size: 13px;
  @include set_theme_color(background-color, input-disabled-bg-color);
}
</style>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.devicePermission {
  &-container {
    // width: 100%;
    height: calc(100% - 60px);
    .el-table__fixed-right-patch {
      display: none;
    }
    .el-dialog {
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 260px;
      }
    }
  }
  &-search {
    @include set_theme_color(background-color, left-menu-bg-color);
    padding: 10px 16px 3px;
    display: flex;
    align-items: center;
  }
}
</style>
